import cls from './Text.module.scss';
import { ParentComponent } from "solid-js";

export const Text: ParentComponent = (props) => (
  <div class={cls.text}>
    {props.children}
  </div>
);